import { delete0, get, post, postForm } from '@/utils/request'

const blogApi = {
  getPost: '/api/blog/post',
  getCategory: '/api/blog/category',
  getArchive: '/api/blog/archive',
  getAbout: '/api/blog/about',
  getSearchList: '/api/blog/search',
  getBlogCategory: '/api/blog/v2/category',
  getBlogPost: '/api/blog/v2/post',
  getBlogQuestion: '/api/blog/v2/question',
  getBlogImage: '/api/file/image'
}

export function getPostList(queryInfo) {
  return get(blogApi.getPost + '/list', queryInfo)
}

export function getPost(postId) {
  return get(blogApi.getPost + '/detail?articleId=' + postId)
}

export function getCategory(queryInfo) {
  return get(blogApi.getCategory, queryInfo)
}

export function getCategoryPost(queryInfo) {
  return get(blogApi.getCategory + '/post', queryInfo)
}

export function getArchive() {
  return get(blogApi.getArchive)
}

export function getAbout() {
  return get(blogApi.getAbout)
}

export function getSearchList(queryInfo) {
  return get(blogApi.getSearchList, queryInfo)
}

// blog 后台接口
export function getBlogCategoryList(queryInfo) {
  return get(blogApi.getBlogCategory + '/list', queryInfo)
}

export function addBlogCategory(formData) {
  return postForm(blogApi.getBlogCategory + '/add', formData)
}

export function deleteBlogCategory(formData) {
  return postForm(blogApi.getBlogCategory + '/delete', formData)
}

export function getBlogPostList(queryInfo) {
  return get(blogApi.getBlogPost + '/list', queryInfo)
}

export function editBlogPost(formData) {
  return postForm(blogApi.getBlogPost + '/edit', formData)
}

export function getBlogEditPost(queryInfo) {
  return get(blogApi.getBlogPost + '/edit', queryInfo)
}

export function deleteBlogPost(formData) {
  return postForm(blogApi.getBlogPost + '/delete', formData)
}

export function resetBlogPostIndex() {
  return post(blogApi.getBlogPost + '/reset_index')
}

export function getBlogQuestionList(queryInfo) {
  return get(blogApi.getBlogQuestion + '/list', queryInfo)
}

export function addBlogQuestionWeight(formData) {
  return postForm(blogApi.getBlogQuestion + '/weight/add', formData)
}

export function minusBlogQuestionWeight(formData) {
  return postForm(blogApi.getBlogQuestion + '/weight/minus', formData)
}

export function getBlogImageList(queryInfo) {
  return get(blogApi.getBlogImage, queryInfo)
}
